import type { AppContextEntry } from '../../chat-app-context'
import { describeEntity } from '../../chat-app-context'

export interface DocsAppContextInput {
  /** Loaded row for the open doc path, when one is open. */
  doc?: { name: string; path: string; id: string }
  /** Selected folder path; mutually exclusive with an open doc. */
  folder?: string
  /** True while the doc is open in the editor rather than the viewer. */
  editing?: boolean
}

/**
 * The URL carries the path; the page has the row, so it offers name + path +
 * id (the path is what the agent's docs tools address) and supersedes the
 * raw route/search params.
 */
export function buildDocsAppContextEntries(input: DocsAppContextInput): AppContextEntry[] {
  const entries: AppContextEntry[] = []

  if (input.doc !== undefined) {
    entries.push({
      key: 'Open doc',
      value: describeEntity({
        name: input.doc.name,
        fields: [['path', `/${input.doc.path}`]],
        id: input.doc.id
      })
    })
    // The lease matters to the agent: it must not try to write a doc a human
    // currently holds open.
    entries.push({ key: 'Doc mode', value: input.editing === true ? 'editing' : 'reading' })
  }

  if (input.folder !== undefined && input.folder !== '') {
    entries.push({ key: 'Folder', value: input.folder })
  }

  return entries
}

/**
 * Baseline path/search params the entries above stand in for.
 * `*` is the resource-path splat from `/documents/…` route matches.
 */
export const DOCS_SUPERSEDED_PARAMS = ['doc', 'folder', '*']
